import React from "react"
import AuthContainer from "../../containers/Auth/AuthForm/AuthContainer";
const Auth = () =>{
    return (
        <AuthContainer/>
    )
}

export default Auth